import * as S from "../../Style/Page/Social.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleSocial.js";
import HatPageTopLine from "../../Component/SocialPageTopLine.js";
const MainImg = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/14. OBS TV.6a4a50bd632be90bca1d.png`;
// const Img1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/15. OBS TV 권역도.fe3ae30a2ae6314ce796.png`;
import Img1 from "../../assets/Obs/TV 권역도.png";
import Img2 from "../../assets/Obs/라디오1.png";
import Img3 from "../../assets/Obs/라디오2.png";
import Img4 from "../../assets/Obs/라디오3.png";
import Img5 from "../../assets/Obs/라디오4.png";
import Img6 from "../../assets/Obs/라디오5.png";
import Img7 from "../../assets/Obs/라디오6.png";
const Img8 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/22. OBS-W.76df08c618bec9ab06eb.png`;
const Obs = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"사회사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/SocialBusiness/SocialService">
                <div className="kor">사회사업</div>
                <div className="eng">Social Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"220px"}>
            <S.NavItem>
              <Link to="/SocialBusiness/Obs">OBS</Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">복지사업</div>
                  <div className="eng">Welfare Services</div>
                </Link>
              </S.NavItem>
               <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Scholarship">
                  <div className="kor">연암장학회</div>
                  <div className="eng">Yeonam Scholarship Foundation</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/EducationBusiness">
                  <div className="kor">교육사업</div>
                  <div className="eng">YoungAn Education Business</div>
                </Link>
              </S.NavItem>
             
              
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Obs">OBS</Link>
              </S.NavItem>
              {/* <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Museum">
                  <div className="kor">영안역사관</div>
                  <div className="eng">YoungAn History Museum</div>
                </Link>
              </S.NavItem> */}
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <div className="title-flex">
              <PageTitle titleko={"OBS TV 소개"} titleeng={"Introduction of OBS TV"} link={"http://www.obs.co.kr/"} />
              <span>
                <div className="kor">대한민국 5대 지상파 방송</div>
                <div className="eng">The five major terrestrial <br /> broadcasters in South Korea</div>
              </span>
            </div>
            <img src={MainImg} alt="" className="fullsize-map" />
            <div className="page-text">
              <div className="page-text-title">
                <div className="kor"><h2>OBS TV</h2></div>
                <div className="eng"><h2>OBS Gyeongin TV</h2></div>
              </div>
              <br /><div className="kor">
                1) 설립일자 : 2006. 8. 30 (2007. 12. 28 개국)
                <br />
                2) 소재지 : 대한민국 경기도 부천시 오정구 오정로233
                <br />
                3) OBS는 인천광역시와 경기도 전역을 기반으로 하는
                지상파민영방송사입니다.
                <br /> 케이블, IPTV, SkyLife(위성)방송을 통해 서울지역에서도
                시청할 수 있습니다.
                <br />
                4) 가시청 인구 : 2,700만명 (경기 1,400만 명, 인천 300만 명, 서울
                1,000만 명)
                <br />
                가시청 가구 : 1,300만 가구
              </div>
              <div className="eng">
                1) Date of establishment : 2006. 8. 30 (Launched on 2007. 12. 28)
                <br />
                2) Location : 233, Ojeong-ro, Ojeong-gu, Bucheon-si, Gyeonggi-do, Korea
                <br />
                3) OBS is a private terrestrial broadcasting company covering Incheon and
                <br />
                Gyeonggi-do area. It also covers Seoul via cable, IPTV,
                <br />
                SkyLife(Satellite) broadcasting.
                <br />
                4) Population in service area : 27 million (Gyeonggi-do : 14 million, Incheon
                <br />
                3 million, Seoul 10 million) / Households in service area : 13 million households
              </div>
              <div className="page-text-title">
                <div className="kor"><h2>국내 전 플랫폼 송출</h2></div>
                <div className="eng"><h2>Transmission via all platforms</h2></div>
              </div>
              <div className="kor">
                1) 지상파 : 8-1번
                <br />
                2) 케이블 : 2번, 25번, 26번 <br />
                3) IPTV : SKB25번, KT26번, LGU+26번
                <br />
                4) SkyLife(위성) : 30번
              </div>
              <div className="eng">
                1) Terrestrial : Channel 8-1
                <br />
                2) Cable : Channel 2, Channel 25, Channel 26
                <br />
                3) IPTV : SKB Channel 25, KT Channel 26, LGU+ Channel 26
                <br />
                4) SkyLife(Satellite) : Channel 30
              </div>
              <img src={Img1} alt="" className="hat-img hat-img-lg" />
            </div>

            <PageTitle
              titleko={"OBS RADIO 소개"}
              titleeng={"YoungAn Broadcasting Business"}
              link={"https://www.obs.co.kr/radio/"}
            />
            <div className="page-subtitle">
              <div className="kor">OBS 라디오 (FM 99.9) 개국 : 2023년 3월 30일</div>
              <div className="eng">OBS-Radio (FM 99.9) : Launched on March 30, 2023)</div>
            </div>

            <div className="page-img-list">
              <img src={Img2} alt="" className="page-img-item" />
              <img src={Img3} alt="" className="page-img-item" />
              <img src={Img4} alt="" className="page-img-item" />
              <img src={Img5} alt="" className="page-img-item" />
              <img src={Img6} alt="" className="page-img-item" />
              <img src={Img7} alt="" className="page-img-item" />
            </div>

            <PageTitle titleko={"OBS-W 소개"} titleeng={"Introduction of OBS PP"} link={"https://www.obsw.co.kr/"} />
            <div className="page-subtitle">
              <div className="kor">OBS-W : OBS 방송을 전국으로 송출중</div>
              <div className="eng">OBS-W : Nationwide broadcasting system for PP</div>
            </div>

            <img src={Img8} alt="" className="fullsize-map" />
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Obs;
